import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { Clinic } from '@app/_models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClinicService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<any>(`${environment.apiUrl}/clinic/Get`);
    }

    /*get(id) {
        return this.http.get(`${environment.apiUrl}/FOOD/GetById?Id=` + id);
    }

    post(food: Food) {
        return this.http.post<Food>(`${environment.apiUrl}/FOOD/InsertOrUpdate`, food);
    }*/

}
